// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import PersonMatches from './data'

export default function PersonMatchesFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/PersonMatches">
      <PersonMatches {...props}>
        {children}
      </PersonMatches>
    </Flow>
  )
}
